import { AccceptButton } from '@src/main/shared/ui/components/button/accept/AcceptButton';
import { CancelButton } from '@src/main/shared/ui/components/button/cancel/CancelButton';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { FC } from 'react';
import styles from './CustomConfirmDialog.module.scss';

interface CustomConfirmDialogProps {
  visible: boolean;
  message?: string;
  header?: string;
  onAccept: () => void;
  onReject: () => void;
}

export const CustomConfirmDialog: FC<CustomConfirmDialogProps> = ({
  visible,
  message,
  header,
  onAccept,
  onReject,
}) => {
  const footer = (
    <div className={styles.footer}>
      <CancelButton onClick={onReject} />
      <AccceptButton onClick={onAccept} />
    </div>
  );

  return (
    <ConfirmDialog
      visible={visible}
      onHide={onReject}
      message={message}
      header={header}
      footer={footer}
    />
  );
};
